var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgUnfoldMore = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "expand_content_FILL0_wght300_GRAD0_opsz20",
    d: "M260-692v-4h.945v3.055H264V-692Zm7.055-4v-3.055H264V-700h4v4Z",
    transform: "translate(-260.001 699.999)",
    fill: "#3953fb"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUnfoldMore, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/UnfoldMore.60374913.svg";
export { ForwardRef as ReactComponent };